import {
  dismissContentCard,
  handleContentCardClicked,
  setContentCards,
  subscribeToContentCards,
  updateContentCard,
} from './content-cards.actions';
import {
  getContentCardById,
  updateContentCardById,
  updateContentCards,
} from './content-cards.repository';
import {
  createEffect,
  dispatch,
  ofType,
  registerEffects,
  removeEffects,
  tapResult,
} from '@ngneat/effects';
import * as braze from '@braze/web-sdk';

const subscribeToContentCards$ = createEffect((actions) =>
  actions.pipe(
    ofType(subscribeToContentCards),
    tapResult(() => {
      const cachedCards = braze.getCachedContentCards();
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const lastUpdated = new Date(cachedCards.lastUpdated ?? '');
      lastUpdated.setHours(0, 0, 0, 0);

      dispatch(setContentCards({ contentCards: cachedCards }));

      braze.subscribeToContentCardsUpdates((contentCards) => {
        dispatch(setContentCards({ contentCards }));
      });
    })
  )
);

const setContentCards$ = createEffect((actions) =>
  actions.pipe(
    ofType(setContentCards),
    tapResult(({ contentCards }) => {
      updateContentCards(contentCards);
    })
  )
);

const handleContentCardClicked$ = createEffect((actions) =>
  actions.pipe(
    ofType(handleContentCardClicked),
    tapResult(({ id }) => {
      const card = getContentCardById(id);
      if (card !== null) {
        braze.logContentCardClick(card);
      }
    })
  )
);

const updateContentCard$ = createEffect((actions) =>
  actions.pipe(
    ofType(updateContentCard),
    tapResult(({ card }) => {
      updateContentCardById(card);
    })
  )
);

const dismissContentCard$ = createEffect((actions) =>
  actions.pipe(
    ofType(dismissContentCard),
    tapResult(({ card }) => {
      if (
        card instanceof braze.ClassicCard ||
        card instanceof braze.CaptionedImage ||
        card instanceof braze.ImageOnly
      ) {
        braze.logCardDismissal(card);
        card.dismissed = true;

        dispatch(updateContentCard({ card }));
      }
    })
  )
);

const effects = [
  subscribeToContentCards$,
  setContentCards$,
  handleContentCardClicked$,
  updateContentCard$,
  dismissContentCard$,
];

export function registerContentCardsEffects() {
  registerEffects(effects);
}

export function deregisterContentCardsEffects() {
  removeEffects(effects);
}
